import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/index';
import { catchError, tap } from 'rxjs/operators';

export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
@Injectable({
  providedIn: 'root'
})
export class SrmMenuService  extends BaseService{
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/config-menu';

  getUrl(): string {
    return this.url;
  }

  getMenuList(params):Observable<any> {
    const url = `${this.getUrl()}/find-by-code`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getMenuList')),
      catchError(this.handleError('getMenuList'))
    );
  }

  getAgendaCountData(id: any[]): Observable<any> {
    const url = `${this.getUrl()}/agenda-count-data`;
    let params = new HttpParams();
    for (let item of id) {
      params = params.append('id', item);
    }
    return this.http.get<any>(url, {
      headers: httpOptions.headers,
      params: params,
    }).pipe(
      tap(_ => this.log(`get object list id=${id}`)),
      catchError(this.handleError<any>('get object list')),
    );
  }
}
